// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.checkbox {
  margin-left: 10px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/core/components/workbooks/workbook-builder/tile-pairing-modal/tile-pairing-modal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AACA;EACE,iBAAA;EACA,kBAAA;AAEF","sourcesContent":[".container{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.checkbox{\n  margin-left: 10px;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
